import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from "@angular/router";
import { OrganizationComponent } from "@app/features-modules/superadmin/components/organization/organization.component";

@Injectable()
export class CanLogoutSAGuard implements CanDeactivate<OrganizationComponent> {
  canDeactivate(
    component: OrganizationComponent,
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot) {
    if ((nextState.url.indexOf('landing-page') > -1)) {
        return component.canLogout();
    } else {
        return true;
    }
  }
}
